import { useState, useEffect, useCallback } from 'react';
import { useApi } from '../hooks/useApi';

// DATOS DEL TITULAR DE LA CUENTA.
//
// Quién responde por el boliche ante TUKIPRO: con el email solo no se puede facturar ni
// reclamar nada. En el alta se piden nombre, documento y teléfono; lo fiscal se carga acá,
// y hace falta cuando la cuenta pasa de la prueba a un plan pago.
//
// Los ve el titular (esta pantalla) y el superadmin. Ni el admin ni el socio: no tienen
// por qué ver el documento ni el domicilio del dueño.
const CAMPOS = [
  ['titular_nombre', 'Nombre y apellido', 'Juan Pérez', 'text'],
  ['titular_dni', 'DNI', '30123456', 'numeric'],
  ['titular_telefono', 'Teléfono', '3544 123456', 'tel'],
  ['titular_razon_social', 'Razón social', 'Tu Boliche S.R.L.', 'text'],
  ['titular_cuit', 'CUIT', '30-12345678-9', 'numeric'],
  ['titular_direccion', 'Domicilio', 'Av. Siempreviva 742', 'text'],
  ['titular_localidad', 'Localidad', 'Villa Carlos Paz', 'text'],
  ['titular_cp', 'Código postal', '5152', 'text'],
];
const FISCALES = new Set(['titular_razon_social', 'titular_cuit', 'titular_direccion', 'titular_localidad', 'titular_cp']);

export default function DatosTitular() {
  const api = useApi();
  const [f, setF] = useState(null);
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  const load = useCallback(() => {
    api.get('/api/org/titular')
      .then(d => { setSt(d); setF(Object.fromEntries(CAMPOS.map(([k]) => [k, d[k] || '']))); })
      .catch(e => setErr(e.message));
  }, []); // eslint-disable-line
  useEffect(() => { load(); }, [load]);

  const set = (k, v) => setF(s => ({ ...s, [k]: v }));

  async function guardar() {
    setBusy(true); setErr(''); setMsg('');
    try {
      const d = await api.put('/api/org/titular', f);
      setSt(d);
      setMsg('Datos guardados.');
      setTimeout(() => setMsg(''), 2500);
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  }

  if (!f) return <div style={{ color: 'var(--ink-600)', fontSize: 13 }}>{err || 'Cargando…'}</div>;

  const faltanFiscales = (st?.faltantes?.fiscales || []).length;

  return (
    <div className="lb-fade" style={{ maxWidth: 620 }}>
      <div className="lb-eyebrow" style={{ marginBottom: 6 }}>Datos del titular</div>
      <p style={{ color: 'var(--ink-700)', fontSize: 14, marginTop: 0, marginBottom: 20, lineHeight: 1.6 }}>
        Quién responde por esta cuenta. Los necesitamos para facturarte el servicio; no se muestran
        en tu web ni los ve el resto de tu equipo.
      </p>

      {msg && <div style={{ border: '1px solid rgba(46,204,113,0.5)', background: 'rgba(46,204,113,0.08)', borderRadius: 6, padding: '12px 16px', marginBottom: 16, fontSize: 13, color: '#2ecc71' }}>{msg}</div>}
      {err && <div className="lb-err" style={{ marginBottom: 16 }}>{err}</div>}

      {faltanFiscales > 0 && (
        <div style={{ border: '1px solid rgba(212,175,55,0.45)', background: 'rgba(212,175,55,0.07)', borderRadius: 6, padding: '12px 16px', marginBottom: 16, fontSize: 12.5, color: '#d4af37', lineHeight: 1.5 }}>
          Faltan los datos de facturación. Podés seguir usando el sistema igual: hacen falta cuando pasás a un plan pago.
        </div>
      )}

      <div className="lb-card" style={{ padding: '24px 26px' }}>
        {CAMPOS.map(([k, label, ph, modo]) => (
          <div key={k} style={{ marginBottom: 14 }}>
            <div className="lb-label" style={{ marginBottom: 5 }}>
              {label}{FISCALES.has(k) && <span style={{ color: 'var(--ink-600)', fontWeight: 400 }}> · facturación</span>}
            </div>
            <input
              className="lb-input" value={f[k]} placeholder={ph}
              inputMode={modo === 'numeric' ? 'numeric' : modo === 'tel' ? 'tel' : undefined}
              onChange={e => set(k, e.target.value)}
            />
          </div>
        ))}

        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginTop: 18 }}>
          <button className="lb-btn lb-btn--primary lb-btn--sm" disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar datos'}</button>
          {st?.titular_actualizado_at && (
            <span style={{ fontSize: 11.5, color: 'var(--ink-600)' }}>
              Última actualización: {new Date(st.titular_actualizado_at).toLocaleDateString('es-AR')}
              {st.titular_actualizado_por === 'superadmin' ? ' · corregido por TukiPro' : ''}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
